import { mapBaseChampionship, mapResourcesList } from '../../../mappers/api2_0';
import { ChampionshipsEndpoints } from '../../../endpoint';
import { GetAllParams } from '../../../endpoint/championships/get-all';

export interface GetAllProps extends GetAllParams {}

export const getAll = (params: GetAllProps) =>
  ChampionshipsEndpoints.getAll(params).then(mapResourcesList(mapBaseChampionship));
